<template>
  <!-- Are you sure modal -->
  <div
    class="modal fade"
    tabindex="-1"
    role="alertdialog"
    aria-labelledby="modal-label"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
            &times;
          </button>
          <h3 id="modal-label" class="modal-title">
            {{ title }}
          </h3>
        </div>
        <div class="modal-body">
          <slot>
            <p>
              {{ body }}
            </p>
          </slot>
        </div>
        <div class="modal-footer">
          <button
            v-if="!hideCancel"
            class="btn btn-info"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
          >
            {{ cancelText || 'Cancel' }}
          </button>
          <button
            v-if="skipBtn"
            class="btn btn-info"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
            @click.prevent="onSkip"
            @keyup.enter="onSkip"
          >
            <i v-if="skipBtnIcon" :class="skipBtnIcon" />
            {{ skipText || 'Skip' }}
          </button>
          <a
            class="btn btn-primary"
            :class="onOkayButtonClass"
            @click.prevent="onOkay"
            @keyup.enter="onOkay"
          >
            <i v-if="okayBtnIcon" :class="okayBtnIcon" />
            {{ okayText || 'Okay' }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import $ from 'jquery';
import events from '../events';

export default {
  name: 'ModalDialog',
  data() {
    return {
      visible: false,

      title: '',
      body: '',
      hideCancel: false,
      okayText: null,
      okayBtnClass: null,
      okayBtnIcon: null,
      skipBtn: false,
      skipBtnIcon: null,
      skipText: '',
      cancelText: null,
      callback: null,
      returnVal: false,
    };
  },
  computed: {
    onOkayButtonClass() {
      return {
        [this.okayBtnClass || 'btn-primary']: true,
      };
    },
  },
  watch: {
    title(newVal) {
      this.visible = !!newVal;
    },
    visible(isVisible) {
      $(this.$el).modal(isVisible ? 'show' : 'hide');
    },
  },
  mounted() {
    // adding eventBus listener
    events.$on(
      events.MODAL_SHOW,
      ({
        title,
        body,
        hideCancel = false,
        callback = null,
        okayText = null,
        cancelText = null,
        okayBtnClass = null,
        okayBtnIcon = null,
        skipBtn = false,
        skipBtnIcon = null,
        skipText = null,
      }) => {
        this.title = title;
        this.body = body;
        this.hideCancel = hideCancel;
        this.okayText = okayText;
        this.okayBtnClass = okayBtnClass;
        this.okayBtnIcon = okayBtnIcon;
        this.cancelText = cancelText;
        this.callback = callback;
        this.returnVal = false;
        this.visible = true;
        this.skipBtn = skipBtn;
        this.skipBtnIcon = skipBtnIcon;
        this.skipText = skipText;
      },
    );

    $(this.$el).on('hide.bs.modal', () => {
      if (this.callback) {
        try {
          this.callback(this.returnVal);
        } catch (e) {
          console.error(e);
        }
      }
      this.title = '';
      this.body = '';
      this.callback = null;
      this.returnVal = false;
      events.$emit(events.MODAL_HIDE, this.returnVal);
    });
  },
  beforeDestroy() {
    // removing eventBus listener
    events.$off(events.MODAL_SHOW);
  },
  methods: {
    async onOkay() {
      this.returnVal = events.RETURN_OK;
      this.visible = false;
    },
    async onSkip() {
      this.returnVal = events.RETURN_SKIP;
      this.visible = false;
    },
  },
};
</script>

<style scoped></style>
